import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export const Timeframe: React.FC<SvgIconProps> = ({ ...props }) => {
  return (
    <SvgIcon {...props} viewBox="0 0 20 20" sx={{ fill: "none" }}>
      <rect width="20" height="20" rx="4" fill="#EC0089" />
      <path
        d="M14.2778 14.8H5.72222V8.2H14.2778M12.4444 4V5.2H7.55556V4H6.33333V5.2H5.72222C5.04389 5.2 4.5 5.734 4.5 6.4V14.8C4.5 15.1183 4.62877 15.4235 4.85798 15.6485C5.08719 15.8736 5.39807 16 5.72222 16H14.2778C14.6019 16 14.9128 15.8736 15.142 15.6485C15.3712 15.4235 15.5 15.1183 15.5 14.8V6.4C15.5 6.08174 15.3712 5.77652 15.142 5.55147C14.9128 5.32643 14.6019 5.2 14.2778 5.2H13.6667V4M13.0556 10.6H10V13.6H13.0556V10.6Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export default Timeframe;
